module.exports = __webpack_public_path__ + "img/ruiyan_01.e811fad4.jpg";